/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class MerchantTypeField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props
    const options = [{ key: 1, text: 'F&B', value: 'f-and-b' }, { key: 2, text: 'Mart', value: 'mart' }]

    return (
      <Form.Select
        fluid
        label="Type"
        options={options}
        placeholder="F&B or Mart"
        onChange={(e, data) => onChange(data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/specialDeal/fields/MerchantTypeField.js